import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { UserProfile } from 'app/model/CORE';
import userImageUrl from 'static-assets/user_50px.png';

interface UserInfoProps {
    userProfile: UserProfile;
}

export class UserInfo extends PureComponent<UserInfoProps> {
    getName = () => {
        const userProfile = this.props.userProfile;
        if (userProfile?.firstName && userProfile?.lastName)
            return userProfile?.firstName + ' ' + userProfile?.lastName;
        return userProfile?.userId;
    };

    render() {
        return (
            <Flex className="user-info-panel">
                <Flex direction="vertical" size="15%" style={{ justifyContent: 'center' }}>
                    <img src={userImageUrl} alt="" style={{ width: '2em', height: '2em', margin: 'auto' }} />
                </Flex>
                <Flex direction="vertical" size="85%">
                    <div style={{ fontWeight: 'bold' }}>{this.getName()}</div>
                </Flex>
            </Flex>
        );
    }
}
